import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { LoadingSkeleton } from "@/components/shared";
import { ScrollToTop } from "./ScrollToTop";
import Index from "@/pages/Index";

/**
 * Lazy-loaded page imports
 * 
 * NOTE: Pages use default exports (not named exports) for React.lazy() compatibility.
 * React.lazy() requires a module with a default export that resolves to a React component.
 * This is the only exception to the codebase's named export convention.
 * 
 * @see https://react.dev/reference/react/lazy
 */
const Shop = lazy(() => import("@/pages/Shop"));
const Product = lazy(() => import("@/pages/Product"));
const DirectCheckout = lazy(() => import("@/pages/DirectCheckout"));
const Success = lazy(() => import("@/pages/Success"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Contact = lazy(() => import("@/pages/Contact"));
const NotFound = lazy(() => import("@/pages/NotFound"));

export const AnimatedRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/shop" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <Shop />
          </Suspense>
        } />
        <Route path="/product/:handle" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <Product />
          </Suspense>
        } />
        <Route path="/success" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <Success />
          </Suspense>
        } />
        <Route path="/faq" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <FAQ />
          </Suspense>
        } />
        <Route path="/contact" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <Contact />
          </Suspense>
        } />
        <Route path="/buy/:handle" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <DirectCheckout />
          </Suspense>
        } />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <NotFound />
          </Suspense>
        } />
      </Routes>
    </>
  );
};
